var map = {
	"./acquisto-api.gif": 98,
	"./bus-ticket.gif": 99,
	"./emma-john.png": 100,
	"./joloj.gif": 101,
	"./joloj.jpg": 102,
	"./joloj.png": 103,
	"./lms.gif": 104,
	"./neural.gif": 105,
	"./news.gif": 106,
	"./pioneer-bank.gif": 107,
	"./quicky-backpack.png": 108,
	"./red-store.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;